import React, { useImperativeHandle, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { StepperFromProps } from 'sharedComponents/dynamicStepperForm/dynamicStepperFormInterface';
import { CheckboxInput } from 'sharedComponents/inputGroup';
import { RootState } from 'store/store';
import TradeInHeader from './header/TradeInHeader';

const Step5: React.ForwardRefRenderFunction<unknown, StepperFromProps> = ({ onNext, onBack }, ref) => {
  // Hooks
  const { t } = useTranslation();

  const hasCalledNextStep = React.useRef(false);

  const { vehicleOptions } = useSelector((state: RootState) => state.tradeInStore);

  // React Hook Form
  const { control, trigger } = useFormContext();

  const vehicleOptionsArray = useMemo(() => {
    return [
      {
        id: 1,
        label: t('stepperFormTradeIn.que1'),
        labelTxt: 'Select any options your vehicle has',
        options: vehicleOptions.map((option: { name: string; _id: string }) => ({
          value: option._id,
          label: option.name,
        })),
      },
    ];
  }, [vehicleOptions]);

  // React Hook Form Trigger
  const nextStep = async () => {
    if (hasCalledNextStep.current) return;
    hasCalledNextStep.current = true;

    onNext?.();
  };

  const backStep = () => {
    onBack?.();
  };

  useImperativeHandle(ref, () => ({
    nextStep,
    backStep,
  }));

  return (
    <div className='dr-widget-steps d-flex flex-column h-100 step-2-1 position-relative'>
      <div className='dr-widget-steps__content'>
        <h2 className='dr-widget-steps__title'>{t('digitalRetailing.subHeading')}</h2>
        <TradeInHeader currentStep={1} />
        <div className='dr-widget-steps__form-wrapper'>
          <div className='tradein'>
            <h5 className='tradein__title'>{t('Vehicle Options')}</h5>

            {vehicleOptionsArray?.map((question) => (
              <>
                <h6 className='select-title'>{t(question.label)}</h6>
                <ul className='vehicle-option-list list-unstyled mb-0'>
                  {question?.options?.map((option: { value: string; label: string }) => (
                    <li>
                      <CheckboxInput
                        name={`${question.id}_${option.value}`}
                        control={control}
                        label={t(option.label)}
                        triggerValidationForField={trigger}
                      />
                    </li>
                  ))}
                </ul>
              </>
            ))}
          </div>
        </div>
      </div>
      <div className='dealer-send-note text-secondary mt-auto'>{t('stepperFormTradeIn.note4')}</div>
    </div>
  );
};

const StepperForm5 = React.forwardRef(Step5);

export default StepperForm5;
